'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _indicator = require('./indicator');

var _indicator2 = _interopRequireDefault(_indicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.input.withConfig({
  componentId: 'eu0w2f-0'
})(['position:absolute;overflow:hidden;margin:0;padding:0;border:0;outline:0;opacity:0;&:focus{& + ', '{box-shadow:0 0 2px 3px ', ';}}&:checked{& + ', '{background:', ' no-repeat center center ', ';background-size:calc(', ' * 0.8) auto;}}'], _indicator2.default, function (p) {
  return p.theme.focusColor;
}, _indicator2.default, function (p) {
  return p.theme.iconCheckbox;
}, function (p) {
  return p.theme.inputBgColor;
}, function (p) {
  return p.theme.spacingUnit;
});